export default "__VITE_ASSET__CFhX2GiO__"